<template>
  <v-dialog v-model="dialog" persistent width="980px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>check</v-icon> Aprobar papeleta con cargo a vacación
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-container grid-list-md class="pa-0" style="min-width: 100%;">
          <v-layout row wrap>
            <v-flex xs12>
              <h4 class="texto">
                <strong>Número:</strong> {{ permiso.numero }}
              </h4>
            </v-flex>
            <v-flex xs12>
              <h4 class="texto">
                <strong>Nombres:</strong> {{ permiso.nombres }}
              </h4>
            </v-flex>
            <v-flex xs12>
              <h4 class="subtitulo-uso">
                <strong>Detalle de vacación </strong>
              </h4>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <!-- permiso nro 24 -->
              <v-data-table
                class="elevation-1 tabla-comprimida-light"
                :items="permiso_detalles"
                :headers="headers"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              v-if="permiso.tipo_permiso == 'PERMISO A CUENTA DE VACACIÓN'"
            >
              <h4>
                <strong>Total horas: {{ horas_solicitadas.toFixed(2) }}</strong>
              </h4>
            </v-flex>
          </v-layout>

          <h3
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <strong>Detalles compensacion</strong>
          </h3>
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <v-flex xs12>
              <v-data-table
                class="elevation-1 tabla-comprimida-light"
                :items="permiso_compensacion"
                :headers="headers2"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{ props.item.diferencia_horas }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout
            class="pa-0"
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <v-flex xs12>
              <h4>
                <strong>Total horas: {{ total_horas_acomuladas }}</strong>
              </h4>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <h4 class="subtitulo-uso">
              <strong>Seguimiento de papeleta</strong>
            </h4>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              class="elevation-1 tabla-comprimida-light"
              :items="detalle_seguimiento"
              :headers="headers_detalle"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.fecha_registro }}</td>
                <td class="text-xs-center">{{ props.item.estado }}</td>
                <td class="text-xs-center">{{ props.item.usuario }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" type="submit" @click.prevent="close()"
          ><v-icon>clear</v-icon>
          Cerrar
        </v-btn>
        <v-btn
          color="success"
          @click.prevent="apruebaPermiso()"
          :loading="loading"
          ><v-icon>check</v-icon>
          Aprobar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
//import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  // components: {
  //   SeguimientoDetalle
  // },
  mixins: [validate],
  props: ["item"],
  mounted() {
    this.$bus.$on("openDialogAprobarRRHHSinPermisosPapeleta", async item => {
      this.permiso = item;

      (this.permiso_detalles = [
        {
          fecha_desde: item.fecha_desde,
          fecha_hasta: item.fecha_hasta,
          hora_desde: item.hora_desde,
          hora_hasta: item.hora_hasta,
          dias: item.dias
        }
      ]),
        this.getDetalleSeguimiemto(item.id_vacacion);
      this.dialog = true;
    });
  },
  data() {
    return {
      usuario: this.$storage.get("user"),
      dialog: false,

      permiso: {
        permiso: {
          motivo: ""
        }
      },
      permiso_compensacion: [],
      permiso_detalles: [],
      permiso_detalles2: [],
      permiso_detalle: [],
      motivo2: [],
      vDetallePermisos: {},

      loading: false,
      headers: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      horas_solicitadas: 0,
      horas_solicitadas_comp: 0,
      detalle_seguimiento: [],
      headers_detalle: [
        {
          text: "Fecha registro",
          sortable: false,
          align: "center"
        },
        {
          text: "Estado",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario",
          sortable: false,
          align: "center"
        }
      ]
    };
  },
  methods: {
    // Envia correo al detinatario del permiso
    async enviarCorreoDestinatario(permiso) {
      let destinatario = await this.$service.obtieneDestinatarioPermiso(
        permiso.id_vacacion
      );
      if (!destinatario) {
        return;
      }
      destinatario = JSON.parse(destinatario);
      var mensaje = `
            <h1>NOTIFICACIÓN APROBACIÓN DE PERMISO</h1>
            Estimado(a): ${destinatario.nombres}<br>El motivo de la presente es para informarle que se le APROBO un permiso con los siguientes datos:<br>
            <b>NOMBRE SOLICITANTE:</b>  <br>${permiso.nombres}<br>
            <b>TIPO DE PERMISO:</b>  <br>Papeleta con cargo a vacación<br>
            <b>NRO PAPELETA:</b>  <br>${permiso.numero}<br>
            <b>FECHA DE SOLICITUD:</b>  <br>${permiso.fecha_permiso}<br>
            <b>FECHA SALIDA - FIN:</b>  <br>${permiso.fecha_desde} - ${permiso.fecha_hasta}<br>
            <b>HORAS:</b>  <br>${permiso.hora_desde} - ${permiso.hora_hasta}<br>
            <br>
            Saludos cordiales.`;
      await this.$service.sendEmail({
        correo: destinatario.correo,
        asunto: "NOTIFICACIÓN APROBACIÓN DE PERMISO",
        mensaje: mensaje.replace(/<[^>]+>/g, ""),
        html: mensaje
      });
    },
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.dialog = false;

      this.permiso = {
        permiso: {
          motivo: ""
        }
      };
      this.$bus.$emit("closeDialogAprobarRRHHSinPermisosPapeleta");
    },

    async apruebaPermiso() {
      const user = this.$storage.get("user");
      const permiso_copia = JSON.parse(JSON.stringify(this.permiso));
      let respuesta = "";
      try {
        respuesta = await this.$service.graphql({
          query: `
								query{
								runQuery(consulta:"select control.fn_aprueba_permiso_general(${parseInt(
                  this.permiso.id_vacacion
                )},77,${this.permiso.id_persona},'${user.id}')"){
									respuesta
								}
								}
							`
        });

        let resp = respuesta.runQuery.respuesta[0].fn_aprueba_permiso_general;
        let resps2 = resp.split("|");

        let correcto = resps2[0];
        if (correcto == "1") {
          this.$message.success("El permiso fué aprobado");
          this.close();
        } else {
          this.$message.error(resps2[1]);
          this.close();
        }
        // ENVIO DE CORREO
        await this.enviarCorreoDestinatario(permiso_copia);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
        let respuesta = [];
        let res = [];
        respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          respuesta = respuesta.runQuery.respuesta;
        }
        //obtener el nuevo seguimiento
        res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `
        });
        if (res.vSeguimientoDetalles.rows.length > 0) {
          res = res.vSeguimientoDetalles.rows;
        }

        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style scoped>
.titulo {
  font-size: 1.07em;
  color: rgb(0, 77, 128);
  font-weight: bold;
  margin: 0 !important;
}
.texto {
  font-size: 1.07em;
  color: rgb(0, 50, 83);
  margin: 0 !important;
}
.subtitulo-uso {
  font-size: 1.35em;
  color: rgb(0, 77, 128);
  font-weight: bolder;
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/AprobarRRHHSinPermisos.vue